import React from 'react';
import LocationAndAge from 'app/components/customer/Registration/Parts/LocationAndAge';

const Step1 = ({ initialValues, onSubmit, experimentVariant }) => {
  return <LocationAndAge initialValues={initialValues} onSubmit={onSubmit} experimentVariant={experimentVariant} />;
};

export default Step1;
